import { MapIcon } from '@heroicons/react/24/outline';
import React from 'react';

import classNames from '../../../utils/classNames';

interface RedirectionMapButtonsProps {
  address: string;
  type?: 'circle' | 'standard' | 'standard-inline';
  buttonClassName?: string;
}

function RedirectionMapButtons({ address, type = 'circle', buttonClassName }: RedirectionMapButtonsProps) {
  const openGoogleMaps = () => {
    if (address) {
      const encodedAddress = encodeURIComponent(address);
      window.open(`https://www.google.com/maps/search/?api=1&query=${encodedAddress}`, '_blank');
    }
  };

  const buttonClass = classNames(
    'p-1 hover:bg-gray-100 focus:outline-none',
    type === 'circle' && 'rounded-full',
    type === 'standard' && 'rounded flex flex-col items-center justify-center text-gray-600',
    type === 'standard-inline' && 'rounded flex items-center justify-center text-gray-600 px-2',
    !address && 'cursor-not-allowed opacity-40',
    buttonClassName,
  );

  return (
    <>
      {address && address.trim().length > 0 && (
        <div className="flex min-w-20 space-x-2">
          <button
            onClick={openGoogleMaps}
            className={buttonClass}
            disabled={!address}
          >
            <MapIcon className="h-5 w-5" />
            {type != 'circle' && (
              <span className="ml-2">Voir sur Google Maps</span>
            )}
          </button>
        </div>
      )}
    </>
  );
}

export default RedirectionMapButtons;
